import React from 'react'
import MealsSummary from './MealsSummary'
import AvailableMeals from './AvailableMeals'

const Meals = () =>{
  return (
    <div>
    <MealsSummary/>
    <AvailableMeals/>
    </div>
  )
}

export default Meals